<template lang="pug">
  section.admin
    h2 Email администратору аккаунта (фирмы)
    p Уведомления всем зарегистрированным в системе пользователям
    .form.notifications__form
      input.notifications__title(
        v-model="subject"
        name="subject"
        id="subject"
        placeholder="Тема уведомления"
      )
      wysiwyg.notifications__message(
        v-model="body"
        name="body"
        id="body"
        placeholder="Сообщение"
      )
      .notifications__channels
        .notifications__channels-item(v-for="item in channels")
          input.notifications__channels-checkbox(
            :id="item.channel + '_checkbox'"
            type="checkbox"
            :value="item.channel"
            v-model="selectedChannels"
          )
          label.notifications__channels-label(
            :for="item.channel + '_checkbox'"
          )
            | {{ item.label }}
      .notifications__submit.btn(
        v-promise-btn
        @click="sendNotfications"
      ) Отправить
</template>

<script>
import apiClient from '@/apiClient';

export default {
  data() {
    return {
      subject: '',
      body: '',
      channels: [
        {
          channel: 'mail',
          label: 'Отправить Email-уведомление'
        },
        {
          channel: 'broadcast',
          label: 'Отправить уведомление в личный кабинет'
        }
      ],
      selectedChannels: ['mail']
    };
  },

  methods: {
    sendNotfications() {
      const { subject, body, selectedChannels } = this;
      const payload = { subject, body, channels: selectedChannels };
      const savePromise = new Promise((resolve, reject) => {
        apiClient
          .post(`/notifications/firms`, payload)
          .then(resp => {
            this.flashSuccess('Уведомление отправлено');
            resolve(resp);
          })
          .catch(err => {
            this.flashError('Что-то пошло не так');
            reject(err);
          });
      });
      return savePromise;
    }
  }
};
</script>

<style lang="scss">
.notifications {
  &__title,
  &__message {
    margin-bottom: 1em;
  }

  &__message {
    min-height: 400px;
  }

  &__channels {
    margin-bottom: 1em;
  }

  &__channels-item {
    display: flex;
    align-items: center;
  }

  &__channels-checkbox {
    margin-right: 0.5em;
  }
}
</style>
